import type { TransactionOperation } from "."
import { findProjectedAreaState } from "../areas"
import { areasOfPanelsIndexState } from "../relations"

export const getSlopeFromPanelArea: TransactionOperation<string, number> = (
  transactors,
  panelId,
) => {
  const { get } = transactors
  const currentAreaId = get(areasOfPanelsIndexState).from(panelId)
  const { slope } = currentAreaId
    ? get(findProjectedAreaState(currentAreaId))
    : { slope: 0 }

  return slope ?? 0
}
